module.exports = __webpack_public_path__ + "img/icon_pumpkin.16ee976e.svg";